<div style="font-size: 14px">
  <mat-card>
   <h6 class="primary">{{ 'MAP.PHOTOGRAM.ESTIMATED_PRICE' | translate }}: USD {{ 'PLAN.CURRENCY' | translate }} {{estimatedPrice}}</h6>
  </mat-card>
  <mat-divider class="mb-2"></mat-divider>
  <mat-card>
    <div>
      <span class="ml-2">


      {{ 'MAP.PHOTOGRAM.IMAGES_TOTAL' | translate }}:
        <input matInput  type="number"  (input)="calculatePrice()" [(ngModel)]="noOfImages">
        </span>
      <span class="ml-2">
        {{ 'MAP.PHOTOGRAM.CAMERA_PX' | translate }}:
        <input matInput  type="number" (input)="calculatePrice()" [(ngModel)]="megapixel">
      </span>

    </div>
  </mat-card>
  <mat-divider class="mb-2"> </mat-divider>
  <mat-card>

    <h5>{{ 'MAP.PHOTOGRAM.CAMERA_PX' | translate }}:
    </h5>

    <br>
    <mat-checkbox (change)="calculatePrice()" [(ngModel)]="doSparse" class="ml-2">
    <span style="padding-bottom: 2px;">
      {{ 'MAP.PHOTOGRAM.ORTHO_VIEW' | translate }}
    </span>
    </mat-checkbox>
    <mat-checkbox (change)="calculatePrice()" [(ngModel)]="doOrtho" class="ml-2">
    <span style="padding-bottom: 2px;">
      {{ 'MAP.PHOTOGRAM.TRUE_ORTHO' | translate }}
    </span>
    </mat-checkbox>
    <mat-checkbox (change)="calculatePrice()" [(ngModel)]="doDense" class="ml-2">
    <span style="padding-bottom: 2px;">
      {{ 'MAP.PHOTOGRAM.DENSE_POINCLOUD' | translate }}
    </span>
    </mat-checkbox>
    <mat-checkbox (change)="calculatePrice()" class="ml-2" [(ngModel)]="doDEM">
    <span style="padding-bottom: 2px;">
      {{ 'MAP.PHOTOGRAM.DIGITAL_ELEVATION' | translate }}
    </span>
    </mat-checkbox>
    <!-- <mat-checkbox (change)="calculatePrice()" class="ml-2" [(ngModel)]="doMesh">
    <span style="padding-bottom: 2px;">
    3D Textured Mesh Model (Suitable for 3D reality modelling, inspection and precise 3D measurement)
    </span>
    </mat-checkbox> -->
  </mat-card>
  <button mat-button  class="warn mt-2" (click)="dialogRef.close(estimatedPrice)">{{ 'GENERIC.CANCEL' | translate }}</button>

</div>
